<template>
  <div class="text-center">
    <v-menu transition="scale-transition" origin="center center">
      <template v-slot:activator="{ on }">
        <v-btn text icon x-small v-on="on">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item v-if="menu.includes('view')" @click="$emit('view', item)">
          <v-list-item-title>
            <v-icon class="mr-1" small>mdi-eye</v-icon>
            {{ $t('ITEM.VIEW') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="menu.includes('edit')" @click="$emit('edit', item)">
          <v-list-item-title>
            <v-icon class="mr-1" small>mdi-pencil</v-icon>
            {{ $t('ITEM.EDIT') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="menu.includes('delete')"
          @click="$emit('delete', item)"
        >
          <v-list-item-title>
            <v-icon class="mr-1" small>mdi-delete</v-icon>
            {{ $t('ITEM.DELETE') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'MenuOfActions',

  props: {
    item: {
      type: Object,
      required: true
    },
    menu: {
      type: Array,
      default() {
        return ['view', 'edit', 'delete'];
      }
    }
  }
};
</script>
